var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.624,
    height: 15.502,
    viewBox: "0 0 16.624 15.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "headset_1_",
    "data-name": "headset(1)",
    d: "M17.624,13.087a3.627,3.627,0,0,0-1.722-3.5c-.082-5.422-2.123-7.846-6.59-7.846S2.8,4.172,2.721,9.608A3.666,3.666,0,0,0,1,13.087c0,3.7,2.749,4.122,4.817,4.122a.755.755,0,0,0,.717-.518,11.524,11.524,0,0,0,0-7.208.756.756,0,0,0-.717-.518,8.825,8.825,0,0,0-1.569.112c.2-4.806,2.178-5.823,5.064-5.823s4.862,1.018,5.064,5.826a9.456,9.456,0,0,0-1.569-.115.755.755,0,0,0-.717.518,11.54,11.54,0,0,0-.271,6.248c-.8.014-1.574-.01-2.3-.069A.756.756,0,0,0,9.4,17.168c.634.051,1.3.077,1.987.077q.706,0,1.444-.036c1.211,0,4.8-.023,4.8-4.122ZM5.26,15.685c-2.017-.1-2.748-.824-2.748-2.6s.731-2.494,2.748-2.6a10.026,10.026,0,0,1,0,5.2Zm8.1,0a10.026,10.026,0,0,1,0-5.2c2.017.1,2.748.824,2.748,2.6s-.731,2.494-2.748,2.6Z",
    transform: "translate(-1 -1.743)",
    fill: "#082654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.3bb85cb903983dbe21e0a5dfe714c3f3.svg";
export { ForwardRef as ReactComponent };